import React, { Fragment } from "react";

const DefaultHeader = () => {
    return (
        <Fragment>
            {/* <span className="text-lg text-coolgrey6 mr-3">Display</span>
            <button id="dropdownDefaultButton" data-dropdown-toggle="dropdown" className="text-white px-4 py-1.5  bg-primary font-medium rounded-full text-center inline-flex items-center " type="button">
                this year
                <FontAwesomeIcon icon={regular("angle-down")} className="ml-2"/>
            </button> */}

            <div id="dropdown" className="z-10 hidden bg-card rounded-card border border-card-bd divide-y divide-border w-44">
                <ul className="py-2 text-sm text-text-2" aria-labelledby="dropdownDefaultButton">
                <li>
                    <a href="/#" className="block px-4 py-2 hover:bg-surface-2">Dashboard</a>
                </li>
                <li>
                    <a href="/#" className="block px-4 py-2 hover:bg-surface-2">Settings</a>
                </li>
                <li>
                    <a href="/#" className="block px-4 py-2 hover:bg-surface-2">Earnings</a>
                </li>
                <li>
                    <a href="/#" className="block px-4 py-2 hover:bg-surface-2">Sign out</a>
                </li>
                </ul>
            </div>
        </Fragment>
    )
}

export default DefaultHeader;